// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthorArticles_wrapper__hJ2h4","blogSearch":"AuthorArticles_blogSearch__ecutr"};